import { FilterOption } from '../interfaces/filteroption.interface';

export class RangeFilterOption implements FilterOption {
  public static TYPE = 'RangeFilterOption';

  name = '';
  label = '';
  count = 0;
  active = false;
  rangeStart?: number;
  rangeEnd?: number;
  readonly type = RangeFilterOption.TYPE;

  constructor(filterOption?: RangeFilterOption) {
    if (filterOption) {
      this.name = filterOption.name;
      this.label = filterOption.label;
      this.count = filterOption.count;
      this.active = filterOption.active;
      this.rangeStart = filterOption.rangeStart;
      this.rangeEnd = filterOption.rangeEnd;
    }
  }

  clone(): FilterOption {
    return new RangeFilterOption(this);
  }
}
